import React, {useContext} from 'react';
import {Snackbar} from '@material-ui/core';
import UIContext from 'sources/contexts/UiContext';

export default function SnackbarContainer() {
    const {data: {snackbarText}, actions: {closeSnackbar}} = useContext(UIContext);
    return (
        <Snackbar
            open={Boolean(snackbarText)}
            onClose={closeSnackbar}
            message={snackbarText}
        />
    )
}



// WEBPACK FOOTER //
// ./src/components/controls/snackbar/SnackbarContainer.jsx